import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';

import {
  TablePagination,
  Box,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import Paper from '@mui/material/Paper';

import TableListHead from '../../layouts/TableListHead';
import ApplicantBody from './ApplicantBody';

import { applySortFilter, getComparator } from '../../halper/TableSort';
import { parseInt } from 'lodash';

function ApplicantHeader({ data, setShowProfile }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('appliedOn');
  const [searched, setSearched] = useState('');
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  let rows = data.map((user) => {
    const percentageScore =
      (user.userId.assessmentData &&
        user.userId.assessmentData.percentageScore) ||
      (user.userId.masterclassAssessment &&
        user.userId.masterclassAssessment.percentageScore);
    let score = 0;
    if (percentageScore) {
      score = parseInt(
        Object.values(percentageScore).reduce((a, b) => a + b, 0) / 4
      );
    }
    return {
      _id: user._id,
      userId: user.userId._id,
      applicantName: user.userId.name || user.userId.firstName || '',
      domain: user.opportunityId.domainId && user.opportunityId.domainId.title,
      roleName:
        user.opportunityId.roleDetails &&
        user.opportunityId.roleDetails.roleTitle,
      company: user.opportunityId.companyId.name,
      appliedOn: user.appliedOn,
      emailAddress: user.userId.email,
      status: user.currentStatus,
      empScore: score,
      source: user.userId.partnerId ? user.userId.partnerId.name : 'Organic',
    };
  });

  const TABLE_HEAD = [
    {
      id: 'applicantName',
      numeric: false,
      disablePadding: true,
      label: 'Applicant Name',
      align: 'left',
    },
    {
      id: 'roleName',
      numeric: false,
      disablePadding: true,
      label: 'Role Name',
      align: 'left',
    },
    {
      id: 'company',
      numeric: false,
      disablePadding: true,
      label: 'Company',
      align: 'left',
    },
    {
      id: 'domain',
      numeric: false,
      disablePadding: true,
      label: 'Domain',
      align: 'left',
    },
    {
      id: 'appliedOn',
      numeric: false,
      disablePadding: true,
      label: 'Applied On',
      align: 'left',
    },
    {
      id: 'emailAddress',
      numeric: false,
      disablePadding: true,
      label: 'Email Address',
      align: 'left',
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: true,
      label: 'Status',
      align: 'left',
    },
    {
      id: 'empScore',
      numeric: true,
      disablePadding: false,
      label: 'Employability Score',
      align: 'left',
    },
    {
      id: 'source',
      numeric: false,
      disablePadding: false,
      label: 'Source',
      align: 'left',
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [applicantdata, setApplicantData] = useState(rows);
  const requestSearch = (searchedVal) => {
    setSearched(searchedVal);
    const searchedValLower = searchedVal.toLowerCase();
    const filteredRows = rows.filter((row) => {
      return row.status.toLowerCase().includes(searchedValLower);
    });
    setApplicantData(filteredRows);
  };

  const filteredUsers = applySortFilter(
    applicantdata,
    getComparator(order, orderBy)
  );

  return (
    <>
      {rows.length ? (
        <>
          <Box sx={{ minWidth: 120, maxWidth: 180 }}>
            <FormControl fullWidth>
              <InputLabel id='demo-simple-select-label'>
                Select Applicant Status
              </InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={searched}
                label='Select Applicant Status'
                onChange={(e) => requestSearch(e.target.value)}
              >
                <MenuItem value=''>All</MenuItem>
                <MenuItem value='Applied'>New</MenuItem>
                <MenuItem value='Viewed'>Viewed</MenuItem>
                <MenuItem value='Shortlisted'>Shortlisted</MenuItem>
                <MenuItem value='Rejected'>Rejected</MenuItem>
                <MenuItem value='Hired'>Hired</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650, shadow: 2, padding: '6px' }}
              aria-label='table'
              size='small'
            >
              <TableListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={rows.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <ApplicantBody
                      key={row._id}
                      row={row}
                      setShowProfile={setShowProfile}
                    />
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 50]}
              component='div'
              count={filteredUsers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </>
      ) : (
        <Box>
          <Typography my={4}>No Applicant found yet</Typography>
        </Box>
      )}
    </>
  );
}

export default ApplicantHeader;
